import React from "react";
import "./LogoLoop.css";


import Marquee from "react-fast-marquee";

function LogoLoop(props) {

  return (
    <Marquee>
      <div class="logo-marquee">
        <img
          src={require("../../assets/gameslogo/cq9.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/ebet.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/jili.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/joker.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/playstar.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/popk.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/evoplay.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">
        <img
          src={require("../../assets/gameslogo/cq9.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/ebet.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/jili.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/joker.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/playstar.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/popk.png")}
          alt="RN69"
          width={40}
        />
      </div>
      <div class="logo-marquee">

        <img
          src={require("../../assets/gameslogo/evoplay.png")}
          alt="RN69"
          width={40}
        />
      </div>
    </Marquee>





  );
}

export default LogoLoop;
